<script setup lang="ts">
interface Props {
    title: string;
    value: string;
    subtitle?: string;
}

defineProps<Props>();
</script>

<template>
    <div class="summary-item">
        <p class="sm-text">{{ title }}</p>
        <p class="value">{{ value }}</p>
        <p v-if="subtitle" class="sm-text">{{ subtitle }}</p>
    </div>
</template>

<style scoped>
.summary-item {
    padding: 20px;
    width: 100%;
    height: 100%;
    min-height: 8.5rem;
    max-height: 8.5rem;
    text-align: center;
    display: flex;
    flex-direction: column;
}

.summary-item p.value {
    color: var(--pure-white);
    font-weight: 300;
    font-size: 27px;
    line-height: 26px;
    margin: 0;
}

.summary-item p.sm-text {
    font-size: 16px;
    color: var(--pure-white);
    margin-bottom: 0.25rem;
}

@media screen and (width <= 1999px) {
    .summary-item p.value {
        font-size: 20px;
    }
}

@media screen and (width <= 993px) {
    .summary-item p.value {
        font-size: 27px;
    }
}

@media screen and (width <= 344px) {
    .summary-item p.value {
        font-size: 18px;
        line-height: 16px;
    }

    .summary-item p.sm-text {
        font-size: 14px;
        margin-bottom: 0;
    }
}
</style>
